// Do not define color as name like green, red, blue...
// Let's define color as purpose of usage like textMedium, bgMedium...
export const primaryColor = '#23527c';
export const primaryDarkerColor = '#1D376E';
export const primaryLighterColor = '#B3D6C6';
export const contrastColor = '#f9f3c9';
export const white = '#fff';
export const borderColor = '#d2d2d2';
export const successColor = '#00BD56';
export const warningColor = '#ffce00';
export const errorColor = '#f04141';
export const infoColor = '#0496FF';
export const textGray = '#5B5A60';
export const bgLightGrey = '#f1f1f1';
export const midGray = '#ececec';

export const ssPurple = '#49346c';
export const ssHoverPurple = '#8161b8';
